import React from 'react';
import PendingPage from '../../components/shared/Pending';
export default function AdminSettings() { return <PendingPage title="Platform settings" description="Marketplace-wide configuration." note="Settings endpoints are not yet exposed. Managed via infrastructure for now." />; }
